
interface constructor {
    name?: string
    width?: number
    height?: number
}

class BreakPoint {
    public name: string;
    public width: number;
    public height: number;

    constructor(p: constructor = {}) {
        this.name = p.name ? p.name : '';
        this.width = p.width ? p.width : 0;
        this.height = p.height ? p.height : 0;
    }
}

export default BreakPoint;